import React, { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import DropdownIcon from '../../assets/icons/DropdownIcon'
import * as Icons from '../../assets/icons'
import { Transition } from '@windmill/react-ui'
import { useSelector } from 'react-redux'
import { useTranslation } from 'react-i18next'

function Icon({ icon, ...props }) {
  const Icon = Icons[icon]
  return <Icon {...props} />
}

function SidebarSubmenu({ route }) {
  const {t}=useTranslation("common")
  const [isDropdownMenuOpen, setIsDropdownMenuOpen] = useState(false)
  const [pendingNotification, setPendingNotification] = useState(false)

  const not = useSelector(state => state.notification?.pending || false);

  useEffect(() => {
    setPendingNotification(not)
  }, [not])
  function handleDropdownMenuClick() {
    setIsDropdownMenuOpen(!isDropdownMenuOpen)
  }

  return (
    <li className="relative px-6 py-3" key={route.name}>
      <button
        className="inline-flex items-center justify-between w-full text-sm font-semibold transition-colors duration-150 hover:text-gray-800 dark:hover:text-gray-200"
        onClick={handleDropdownMenuClick}
        aria-haspopup="true"
      >
        <span className="inline-flex items-center">
          <Icon className="w-5 h-5 shrink-0" aria-hidden="true" icon={route.icon} />
          <span className="ml-4">{route.name}</span>
        </span>
        <DropdownIcon className="w-4 h-4" aria-hidden="true" />
      </button>
      <Transition
        show={isDropdownMenuOpen}
        enter="transition-all ease-in-out duration-300"
        enterFrom="opacity-25 max-h-0"
        enterTo="opacity-100 max-h-xl"
        leave="transition-all ease-in-out duration-300"
        leaveFrom="opacity-100 max-h-xl"
        leaveTo="opacity-0 max-h-0"
      >
        <ul
          className="p-2 mt-2 space-y-2 overflow-hidden text-sm font-medium text-gray-500 rounded-md shadow-inner bg-gray-50 dark:text-gray-400 dark:bg-gray-900"
          aria-label={t("submenu")}
        >
          {route.routes.map((r) => (
            <li
              className="px-2 py-1 transition-colors duration-150 hover:text-gray-800 dark:hover:text-gray-200"
              key={r.name}
            >
              <Link className={`w-full ${r.path == '/alerts' && "step4"}`} to={r.path}>
                {r.name}
                {r.name == "Alerts" && pendingNotification &&
                  <div
                    className="absolute right-0 m-2 flex items-center justify-center w-3 h-3 bg-[#0071BC] shadow-lg rounded-full"
                    role="status"
                    aria-label={t('you_have_new_alert')}
                    title={t('you_have_new_alert')}
                  >
                    <span className="text-white text-[7px] font-bold leading-none">!</span>
                  </div>
                }
              </Link>
            </li>
          ))}
        </ul>
      </Transition>
    </li>
  )
}

export default SidebarSubmenu